<template>
  <el-dialog
    class="dialog"
    title="编辑分管工作"
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    width="680px"
    destroy-on-close
    :before-close="handleClose"
  >
    <div class="content">
      <div class="section-header">分管工作</div>
      <div class="main-work">
        <!-- <div class="child-title" v-if="partyList && partyList.length > 0">党委工作</div> -->
        <el-checkbox-group v-model="workInfo.party" @change="handlePartyChange">
          <el-checkbox
            class="checkboxItem"
            v-for="item in partyList"
            :label="item.key"
            :key="item.id"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
        <!-- <div class="child-title" v-if="govList && govList.length > 0">政府工作</div> -->
        <el-checkbox-group v-model="workInfo.gov" @change="handleGovChange">
          <el-checkbox
            class="checkboxItem"
            v-for="item in govList"
            :label="item.key"
            :key="item.id"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
        <div class="child-title">其他工作</div>
        <el-input
          class="inputContent"
          type="textarea"
          :rows="4"
          maxlength="250"
          show-word-limit
          v-model="workInfo.otherWork"
          placeholder="请输入其他分管工作，多项工作用'，'分割"
        ></el-input>
      </div>

      <div class="section-header">协助工作</div>
      <el-input
      class="inputContent"
        type="textarea"
        :rows="4"
        maxlength="250"
        show-word-limit
        v-model="workInfo.helpWork"
        placeholder="请输入协助工作"
      ></el-input>
      <div class="section-header">分管部门（单位）</div>
      <el-input
        class="inputContent"
        type="textarea"
        :rows="4"
        maxlength="250"
        show-word-limit
        v-model="workInfo.manageDept"
        placeholder="请输入分管部门（单位）"
      ></el-input>
      <div class="section-header">联系部门（单位）</div>
      <el-input
        type="textarea"
        :rows="4"
        maxlength="250"
        show-word-limit
        v-model="workInfo.contactDept"
        placeholder="请输入联系部门（单位）"
      ></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" @click="confirm" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import vue from "../../../main";
import { getSysparamTree } from "@/api/sysParam";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      partyList: [],
      govList: [],
      workInfo: {
        party: [],
        partyWorkName: "",
        gov: [],
        govWorkName: "",
        otherWork: "",
        helpWork: "",
        manageDept: "",
        contactDept: "",
      },
    };
  },
  watch: {

  },
  created() {
    this.getSysParamByType();
  },
  methods: {
    setWorkInfo(val) {
      this.workInfo = Object.assign(this.workInfo, val);
    },
    // 获取多个数据字典
    getSysParamByType() {
      getSysparamTree({ type: 'MANAGE_WORK' }).then((res) => {
        if (!res || res.code != 0) return;
        if (res.data && res.data.length > 0) {
          let manageTypes = res.data[0].children;
          manageTypes.forEach(item => {
            if (item.name == '党委工作') {
              this.partyList = item.children;
            }
            if (item.name == '政府工作') {
              this.govList = item.children;
            }
          });
        }

      });
    },
    // 党政工作多选
    handlePartyChange(val) {
      let names = this.partyList.filter(item => val.includes(item.key)).map(o => o.name);
      this.workInfo.partyWorkName = names.join(',');
    },
    // 政府工作多选
    handleGovChange(val) {
      let names = this.govList.filter(item => val.includes(item.key)).map(o => o.name);
      this.workInfo.govWorkName = names.join(',');
    },

    // 关闭
    handleClose() {
      this.$emit("close");
    },
    // 确定
    confirm() {
      this.$emit("confirm", this.workInfo);
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  /deep/ .el-dialog__body {
    max-height: 500px;
    overflow-y: scroll;
    padding: 20px;
  }
  /deep/ .el-checkbox__label {
    width: 100px !important;
    display: inline-grid;
    white-space: pre-line;
    word-wrap: break-word;
  }
  /deep/ .el-checkbox__label {
    margin: 0;
  }
  .checkboxItem {
    margin-bottom: 12px;
  }
  .content {
    .section-header {
      background-color: rgba(242, 242, 242, 1);
      font-size: 14px;
      font-weight: bold;
      padding-left: 10px;
      padding-top: 6px;
      padding-bottom: 6px;
      margin-bottom: 16px;
    }
    .main-work {
      margin-left: 10px;
    }
    .inputContent {
      margin-bottom: 16px;
    }
    .child-title {
      margin-top: 16px;
      margin-bottom: 16px;
      font-size: 12px;
      font-weight: bold;
    }
  }
}
</style>
